import { ResourceStoreContext, RouterContext, RouterDataContext } from 'react-resource-router';

import {
  GOAL_DIRECTORY_ARCHIVED_PAGE,
  GOAL_DIRECTORY_FOLLOWING_PAGE,
  GOAL_DIRECTORY_PAGE,
  PROJECT_DIRECTORY_PAGE,
  TAGS_DIRECTORY,
} from '@townsquare/config/routes';
import { RelayResourceConfig, createRelayResource } from '@townsquare/relay-utils';
import { ResourceContext } from '@townsquare/router';

import ExplainerQuery, { TqlExplainerQuery, TqlEntity } from '../components/__generated__/TqlExplainerQuery.graphql';

const getEntity = (routeName: string): TqlEntity | null => {
  switch (routeName) {
    // Setting goal entities for goals app directory routes
    case GOAL_DIRECTORY_FOLLOWING_PAGE:
      return 'GOAL';
    case GOAL_DIRECTORY_ARCHIVED_PAGE:
      return 'GOAL';
    // Setting entity for relevant directories
    case PROJECT_DIRECTORY_PAGE:
      return 'PROJECT';
    case GOAL_DIRECTORY_PAGE:
      return 'GOAL';
    case TAGS_DIRECTORY:
      return 'TAG';
    default:
      return null;
  }
};

export const getTqlExplainerResourceQuery = (
  routerContext: RouterContext | RouterDataContext,
  resourceContext: ResourceStoreContext,
): RelayResourceConfig<TqlExplainerQuery> => {
  const { workspace, collabContext } = resourceContext as ResourceContext;
  const entity = getEntity(routerContext.route.name);
  const { tql, viewUuid } = routerContext.query;
  const hasTqlOrViewUuidAndEntity = (!!tql || !!viewUuid) && !!entity;

  return {
    query: ExplainerQuery,
    variables: {
      entity,
      tql,
      directoryViewUuid: viewUuid,
      workspaceUuid: workspace?.UUID,
      containerId: collabContext?.contextId,
      hasTqlOrViewUuidAndEntity,
    },
    options: {
      fetchPolicy: 'store-and-network',
    },
  };
};

export const tqlExplainerResource = createRelayResource<TqlExplainerQuery>({
  getQuery: getTqlExplainerResourceQuery,
});
